import { render } from "./ListDataSakitAll.vue?vue&type=template&id=24b9940b"
import script from "./ListDataSakitAll.vue?vue&type=script&lang=js"
export * from "./ListDataSakitAll.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__